import { ORDER_HISTORY_REPORT_FILE_TYPES_API } from 'constants/AppConstants';
import { retryAPI } from 'utils/app.utils';

export default async (reportIds) => {
  try {
    const response = await retryAPI(() => fetch(
      ORDER_HISTORY_REPORT_FILE_TYPES_API,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reportIds }),
      },
    ));

    const json = await response.json();
    if (!response.ok) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
